<template>
  <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>

export default {
    components: {
      
    }
}
</script>

<style>
.W60 {
    width:60px !important;
} 
.W80 {
    width:80px !important;
    min-width:80px !important;
    white-space:nowrap;
    word-break:keep-all;
} 
.W90 {
    width:90px !important;
    min-width:90px !important;
    white-space:nowrap;
    word-break:keep-all;
}
.W100 {
    width:100px !important;
    min-width:100px !important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
} 
.W120 {
    width:120px !important;
    min-width:120px !important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
}
.W130 {
    width:130px !important;
    min-width:130px !important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
} 
.W140 {
    width:140px !important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
} 
.W150 {
    width:150px !important;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    word-break:keep-all;
}
.W155 {
    width:155px !important;
    min-width:155px !important;
    white-space:nowrap;
    word-break:keep-all;
}
.W160 {
    width:160px !important;
    min-width:160px !important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    word-break:keep-all;
}
.W170 {
    width:170px !important;
    min-width:170px !important;
    white-space:nowrap;
    word-break:keep-all;
}
.W180 {
    width:180px !important;
    min-width:180px !important;
    white-space:nowrap;
    word-break:keep-all;
}
.nowrap-visible {
    overflow:visible !important;
    text-overflow:clip !important;
    white-space:nowrap !important;
    word-break:keep-all !important;
}
.order-page {
    max-width:100% !important;
    overflow-x:hidden;
}
.order-table-container {
    width:100%;
    max-width:1500px;
    margin:5px auto;
}
.order-table-row {
    justify-content:center;
    margin-left:0 !important;
    margin-right:0 !important;
}
.order-table {
    width:auto !important;
    margin-left:auto;
    margin-right:auto;
}
</style>
